import React from 'react';
import Router from './Router';
import { AuthProvider } from './context/AuthContext';
import EmbeddedBrowserNotice from './components/EmbeddedBrowserNotice';

import 'primereact/resources/themes/lara-dark-teal/theme.css';
import 'primeicons/primeicons.css';
import '/node_modules/primeflex/primeflex.css';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <EmbeddedBrowserNotice />
      <Router />
    </AuthProvider>
  );
}

export default App;
